import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';
import { asyncPreactWidget } from '../../utils/async-preact-widget';
import * as preactWidgets from '../../preact/widgets';
import {
  hasLmpTab,
  isHoroscopeAffinity,
  isHoroscopeDetailSignPage,
  isHoroscopeHomepage,
  isMeaningNamePage,
} from '../../utils/aem-utils';

export const asyncToolbarCalendar = () => {
  const $archiveToolbarNode = document.querySelector('.j-archive-toolbar');
  const $archiveToolbarDataNode = document.querySelector('.j-archive-toolbar-data');
  if ($archiveToolbarNode && $archiveToolbarDataNode) {
    const { start, getInit, error } = asyncModule(JSModules.toolbarCalendarModule);
    start();
    import('../../components/calendar/toolbar-calendar')
      .then(getInit({ $archiveToolbarNode, $archiveToolbarDataNode }))
      .catch(error);
  }
};

export const asyncInjectHomepage = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.injectedHomepageModule);
  if (shouldInit()) {
    start();
    import('../../components/injected-homepage/injected-homepage').then(getInit()).catch(error);
  }
};

export const asyncTvCardOnRailChangePosition = () => {
  const $element = document.querySelector('.j-tv-card-rail');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.tvCardRailChangePositionModule);
    start();
    import('../../components/templating/tv-card-rail').then(getInit($element)).catch(error);
  }
};

export const asyncTvCardSlim = () => {
  const $element = document.querySelector('.j-tv-card-slim');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.tvCardSlimModule);
    start();
    import('../../components/templating/tv-card-slim').then(getInit($element)).catch(error);
  }
};

export const asyncSectionDividerSpecial = () => {
  const $element = document.querySelector('.j-section-divider--special');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.sectionDividerSpecialModule);
    start();
    import('../../components/section-divider/section-divider-special').then(getInit($element)).catch(error);
  }
};

export const asyncPrimaryTag = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.primaryTagModule);
  if (shouldInit()) {
    start();
    import('../../components/primary-tag/primary-tag').then(getInit()).catch(error);
  }
};

export const asyncPathbreakerSlider = () => {
  const $element = document.querySelector('.j-pathbreaker');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.pathBreakerModule);
    start();
    import('../../components/pathbreaker/pathbreaker').then(getInit()).catch(error);
  }
};

export const asyncSignsAffinity = () => {
  if (isHoroscopeAffinity() || isHoroscopeDetailSignPage()) {
    const { start, getInit, error } = asyncModule(JSModules.affinityCalculatorModule);
    start();
    import('../../components/horoscope/affinity').then(getInit()).catch(error);
  } else if (isHoroscopeHomepage()) {
    const { start, getInit, error } = asyncModule(JSModules.favouriteSignModule);
    start();
    import('../../components/horoscope/favorite-sign').then(getInit()).catch(error);
  } else if (isMeaningNamePage()) {
    const { start, getInit, error } = asyncModule(JSModules.setFilterByInitialModule);
    start();
    import('../../components/horoscope/significato-list-name').then(getInit()).catch(error);
  }
};

export const asyncCarouselInline = () => {
  const { isOnPage, shouldInit, start, hydrate, error } = asyncPreactWidget(preactWidgets.carouselInline);
  if ((isOnPage() && shouldInit()) || hasLmpTab()) {
    start();
    import(`../../preact/widgets/carousel-inline`).then(hydrate).catch(error);
  }
};

export const asyncInfiniteScrolling = () => {
  const $element = document.querySelector('.infinite-scrolling');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.infiniteScrollingModule);
    start();
    import('../../components/infinite-scroll/infinite-scroll').then(getInit($element)).catch(error);
  }
};

export const asyncCheckFilters = () => {
  const $elements = document.querySelectorAll('.j-filter');
  if ($elements.length) {
    const { start, getInit, error } = asyncModule(JSModules.checkFiltersModule);
    start();
    import('../../components/filters/filters-toolbar').then(getInit($elements)).catch(error);
  }
};

export const asyncSlimBannerBottomCTA = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.slimBannerBottomCTA);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/slim-banner-bottom-CTA`).then(hydrate).catch(error);
  }
};

export const asyncSlimBannerBottomWPN = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.slimBannerBottomWPN);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/slim-banner-bottom-WPN`).then(hydrate).catch(error);
  }
};

export const asyncTextToSpeech = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.textToSpeech);
  if (isOnPage() || hasLmpTab()) {
    start();
    import(`../../preact/widgets/text-to-speech`).then(hydrate).catch(error);
  }
};
